// T2T-05-C3-UI — Floating dropdown that appears when "@" is typed.

import React from "react";
import PropTypes from "prop-types";

export default function MentionPicker({ rows, onPick, onDismiss }) {
  if (!rows || rows.length === 0) return null;

  return (
    <div
      role="listbox"
      onMouseLeave={onDismiss}
      style={{
        position: "absolute",
        bottom: "100%", left: 0, right: 0,
        marginBottom: 4,
        background: "var(--t2t-surface)",
        border: "1px solid var(--t2t-border)",
        borderRadius: "var(--t2t-radius)",
        boxShadow: "var(--t2t-shadow)",
        maxHeight: 220,
        overflowY: "auto",
        zIndex: 30,
      }}
    >
      {rows.map((u) => (
        <button
          key={u.user_id}
          type="button"
          role="option"
          aria-selected="false"
          onClick={() => onPick(u)}
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "6px 10px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            textAlign: "left",
            borderBottom: "1px solid var(--t2t-border)",
          }}
          className="t2t-mention-row"
        >
          <span
            aria-hidden
            style={{
              width: 22, height: 22, borderRadius: "50%",
              background: u.is_external ? "var(--t2t-navy)" : "var(--t2t-primary)",
              color: "#FFF", fontSize: 9, fontWeight: 700,
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}
          >
            {(u.user_name || "?").trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase()).join("")}
          </span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: "block", fontSize: 12, fontWeight: 600, color: "var(--t2t-text-primary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {u.user_name || u.user_email || "Unknown"}
            </span>
            <span style={{ display: "block", fontSize: 10, color: "var(--t2t-text-muted)" }}>
              {u.role_name || (u.is_external ? "External vendor" : "—")}
            </span>
          </span>
          {u.is_external && (
            <span style={{ fontSize: 9, fontWeight: 700, color: "#FFF", background: "var(--t2t-navy)", padding: "1px 6px", borderRadius: 4 }}>
              EXTERNAL
            </span>
          )}
          {u.is_admin && !u.is_external && (
            <span style={{ fontSize: 9, fontWeight: 700, color: "var(--t2t-purple)", border: "1px solid var(--t2t-purple)", padding: "1px 6px", borderRadius: 4 }}>
              ADMIN
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

MentionPicker.propTypes = {
  rows:      PropTypes.array.isRequired,
  onPick:    PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
